import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@storable/canaveral-components';
import Button from '../../../../modules/react/components/stateless/Button';


const propTypes = {
  buttonText: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  onDismiss: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  confirmButtonContext: PropTypes.string,
};

const defaultProps = {
  buttonText: 'Submit',
  confirmButtonContext: 'negative',
};

const ConfirmationModal = ({
  buttonText, children, onDismiss, onConfirm, show, title, confirmButtonContext,
}) => (
  <Modal
    show={show}
    onDismiss={onDismiss}
    aria-labelledby="confirmation-modal"
  >
    <Modal.Header>
      <Modal.Title id="confirmation-modal">{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>{children}</p>
    </Modal.Body>
    <Modal.Footer>
      <Button size="sm" context="neutral" onClick={onDismiss}>
        Cancel
      </Button>
      <Button size="sm" context={confirmButtonContext} onClick={onConfirm}>
        {buttonText}
      </Button>
    </Modal.Footer>
  </Modal>
);

ConfirmationModal.propTypes = propTypes;
ConfirmationModal.defaultProps = defaultProps;

export default ConfirmationModal;
